/**
 *  @class
 *  @function FullMenuHorizontal
 */
if (!customElements.get('full-menu-horizontal')) {
  class FullMenuHorizontal extends HTMLElement {
    constructor() {
      super();
      this.cc = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');
    }
    connectedCallback() {
      // Toggle aria-expanded on hover for accessibility — mega-menu parents have no
      // .sub-menu, so this must sit above the this.submenus early return.
      this.querySelectorAll('.thb-full-menu > .menu-item-has-children').forEach((item) => {
        const link = item.querySelector(':scope > a');
        if (!link) return;
        item.addEventListener('mouseenter', () => link.setAttribute('aria-expanded', 'true'));
        item.addEventListener('mouseleave', () => link.setAttribute('aria-expanded', 'false'));
      });

      if (!this.submenus.length) {
        return;
      }
      this._onResize = debounce(() => this.resizeSubMenus(), 100);

      document.fonts.ready.then(() => {
        window.addEventListener('resize', this._onResize);
      });
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        const subSubmenus = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');

        subSubmenus.forEach((subSubmenu) => {
          const submenuRect = subSubmenu.getBoundingClientRect();
          const submenuRightEdge = submenuRect.left + submenuRect.width;
          const submenuIsOverflowing = submenuRightEdge > window.innerWidth;

          if (submenuIsOverflowing) {
            subSubmenu.parentElement.classList.add('left-submenu');
          } else {
            subSubmenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu-horizontal', FullMenuHorizontal);
}